import { render, staticRenderFns } from "./ScsDictSelectTag.vue?vue&type=template&id=1ce9b4f2&scoped=true&"
import script from "./ScsDictSelectTag.vue?vue&type=script&lang=js&"
export * from "./ScsDictSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce9b4f2",
  null
  
)

export default component.exports